// extracted by mini-css-extract-plugin
export default {"footer":"App_footer__aawhi","banner-apps":"App_banner-apps__FxHYJ"};